import React, { useEffect } from 'react';
import './About.css';
import ReactGA from "react-ga4";
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function About() {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'auto' // This will make it jump to the top without smooth scrolling
  });
  const location = useLocation()
  useEffect(()=>{
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'About Page' });
  }, []);
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>About</title>
      </Helmet>
      <div className="container my-4">
        <div className="row">
          <div className="col-12 d-flex justify-content-center">
            <div className="video-container">
              <iframe className="responsive-iframe" src="https://www.youtube.com/embed/e0tjgTWaRk0" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12 text-center-wide">
            <h1>What we do</h1>
            <p>We work with local partners around the globe to identify key areas where
              mangroves can flourish and partner with local communities to plant and
              maintain critical eco environments. Why mangroves? </p>
          </div>
          <div className="col-md-6">
            <img src="/img/img/mangroves2.jpg" className="img-fluid" alt="" />
          </div>
          <div className="col-md-6">
            <p style={{color: 'green', fontSize: '13px'}}>
              Mangroves are super plants known for their unique ability to
              capture and store carbon in the soil where they grow. The sediments
              under mangroves contain an average of three to five times as much carbon
              as the soils in tropical rain forests. While they only
              make up 2% of the global habitat, they account for up to 15% of carbon
              burial, with one acre of mangroves storing over 1,450 pounds of carbon
              per year. This equates the emissions by a gas guzzling car traveling
              across the country twice. One study shows mangrove carbon storage being
              over 75 billion pounds of carbon per year!</p>
            <p style={{color: 'green', fontSize: '13px'}}>Mangroves grow where most plants cannot while removing high
              concentrations of carbon and producing
              high levels of oxygen and can be very shrub-like or grow to be over 100 ft tall. As they grown, they
              remove the carbon from carbon dioxide in the atmosphere to leverage it into critical building blocks
              for their growth. They can transform a coastline from a bleak region to a thriving forest. As unique
              survivors in harsh environments, they also restore habitats for hundreds of species of other plants,
              animals, and fish. Mangrove forests become important feeding grounds for these animals and their
              roots also recycle nutrients. They thrive in hot, muddy, salty conditions that would kill most
              plants, with a complex root system that holds the trees amidst shifting sediments with variable
              water levels. Some species live close to shore and get flooded with salt water daily with the tides
              while others grow in fresh water streams or areas with brackish combinations with oxygen-poor soil.
              There are roughly 54 species of mangroves with specific varieties exceling in diverse ecosystems.
              Their seeds, called ‘propagules’, fall from the tree where waters may carry them great distances
              before they sink into the soil.</p>

              <p style={{color: 'green', fontSize: '13px'}}>
              Mangroves represent 0.6% of all the world's tropical forests but their deforestation accounts for as much as 12% of greenhouse gas emissions that come from all tropical deforestation." reference footer:  <a href="https://www.sciencedaily.com/releases/2018/09/180927145314.htm" target="_blank">https://www.sciencedaily.com/releases/2018/09/180927145314.htm</a>
              </p>
              
          </div>
        </div>
      </div>
      {/* Back to Top */}
      <a href="#" className="btn btn-lg btn-primary btn-lg-square rounded-circle back-to-top"><i className="bi bi-arrow-up" /></a>
    </div>
  );
}

export default About;